import { lazy, Suspense } from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/landing/Hero';
import { Seo } from '@/components/Seo';

// Below-the-fold sections — lazy to keep initial JS small (better LCP/TBT on mobile).
const Comparison = lazy(() => import('@/components/landing/Comparison').then((m) => ({ default: m.Comparison })));
const BeforeAfterShowcase = lazy(() =>
  import('@/components/landing/BeforeAfterShowcase').then((m) => ({ default: m.BeforeAfterShowcase }))
);
const HowItWorks = lazy(() => import('@/components/landing/HowItWorks').then((m) => ({ default: m.HowItWorks })));
const ChromeExtension = lazy(() => import('@/components/landing/ChromeExtension').then((m) => ({ default: m.ChromeExtension })));
const PromptLibrarySection = lazy(() => import('@/components/landing/PromptLibrarySection').then((m) => ({ default: m.PromptLibrarySection })));
const MyPromptsSection = lazy(() => import('@/components/landing/MyPromptsSection').then((m) => ({ default: m.MyPromptsSection })));
const Benefits = lazy(() => import('@/components/landing/Benefits').then((m) => ({ default: m.Benefits })));
const Pricing = lazy(() => import('@/components/landing/Pricing').then((m) => ({ default: m.Pricing })));
const Testimonials = lazy(() => import('@/components/landing/Testimonials').then((m) => ({ default: m.Testimonials })));
const CTA = lazy(() => import('@/components/landing/CTA').then((m) => ({ default: m.CTA })));
const ExitIntentPopup = lazy(() => import('@/components/landing/ExitIntentPopup').then((m) => ({ default: m.ExitIntentPopup })));

const SectionFallback = ({ height = 480 }: { height?: number }) => (
  <section aria-hidden="true" style={{ minHeight: height }} />
);

const Index = () => {
  return (
    <div className="min-h-screen relative">
      <Seo
        title="PromptCodex — Transforme suas ideias em prompts otimizados"
        description="Descreva sua ideia em linguagem natural e receba prompts otimizados + a melhor IA recomendada para cada tarefa (Claude, Gemini, GPT)."
        path="/"
      />
      {/* Liquid Glass background orbs (refraction source) — reduced size to keep paint cheap on mobile */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="liquid-orb" style={{ top: '-10%', left: '-10%', width: '460px', height: '460px', background: 'hsl(252 100% 67%)' }} />
        <div className="liquid-orb" style={{ top: '30%', right: '-15%', width: '520px', height: '520px', background: 'hsl(199 89% 48%)', opacity: 0.3 }} />
        <div className="liquid-orb" style={{ bottom: '-10%', left: '20%', width: '480px', height: '480px', background: 'hsl(280 65% 60%)', opacity: 0.25 }} />
      </div>
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<SectionFallback height={420} />}>
          <Comparison />
        </Suspense>
        <Suspense fallback={<SectionFallback height={520} />}>
          <BeforeAfterShowcase />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <HowItWorks />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <ChromeExtension />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <PromptLibrarySection />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <MyPromptsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <Benefits />
        </Suspense>
        <Suspense fallback={<SectionFallback height={520} />}>
          <Pricing />
        </Suspense>
        <Suspense fallback={<SectionFallback height={420} />}>
          <Testimonials />
        </Suspense>
        <Suspense fallback={<SectionFallback height={300} />}>
          <CTA />
        </Suspense>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <ExitIntentPopup />
      </Suspense>
    </div>
  );
};

export default Index;
